<template>
  <b-form>
    <!-- Name -->
    <b-form-group id="brandGroup" label="Marca" label-for="brand">
      <b-form-input
        id="brand"
        name="brand"
        type="text"
        v-model.trim="vehicle.brand"
        v-validate="'required|min:2'"
        placeholder="Marca Vehiculo"/>
      <span class="text-danger">{{ errors.first('brand') }}</span>
    </b-form-group>

    <!-- Surname -->
    <b-form-group id="modelGroup" label="Modelo" label-for="model">
      <b-form-input
        id="model"
        name="model"
        type="text"
        v-model.trim="vehicle.model"
        v-validate="'min:1'"
        placeholder="Modelo Vehículo"/>
      <span class="text-danger">{{ errors.first('model') }}</span>
    </b-form-group>

    <!-- Phone -->
    <b-form-group id="carPlateGroup" label="Matrícula" label-for="carPlate">
      <b-form-input
        id="carPlate"
        name="carPlate"
        type="text"
        v-model.trim="vehicle.carPlate"
        v-validate="'min:2'"
        placeholder="Matrícula"/>
      <span class="text-danger">{{ errors.first('carPlate') }}</span>
    </b-form-group>

    <!-- Edit mode only -->
    <template v-if="!isNewVehicle">
      <!-- Activo / Inactivo -->
      <b-form-group label="Estado empleado:">
        <b-form-radio v-model="vehicle.isActive" name="product-status" :value="true">Activo</b-form-radio>
        <b-form-radio v-model="vehicle.isActive" name="product-status" :value="false">Inactivo</b-form-radio>
      </b-form-group>
    </template>

    <br>

    <b-button v-if="isNewVehicle" @click="validateForm" variant="primary">
      Crear Vehículo
      <b-spinner v-if="isVehicleBtnLoading" small type="grow"></b-spinner>
    </b-button>
    <b-button v-else @click="validateForm" variant="primary">
      Actualizar Vehículo
      <b-spinner v-if="isVehicleBtnLoading" small type="grow"></b-spinner>
    </b-button>
  </b-form>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VehicleForm',
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'isVehicleBtnLoading'
    ]),
    isNewVehicle () {
      return this.$route.name === 'VehicleNew'
    }
  },
  methods: {
    onCreate () {
      const data = {
        ...this.vehicle,
        isActive: true
      }
      this.$emit('onCreate', data)
    },
    onUpdate () {
      this.$emit('onUpdate', this.vehicle)
    },
    validateForm () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.isNewVehicle ? this.onCreate() : this.onUpdate()
          }
        })
    }
  }

}
</script>
